import api from './api';
import type { Collaborateur, CreateCollaborateurRequest, UpdateCollaborateurRequest } from '../types';

export const collaborateursService = {
  async list(filters?: { serviceId?: string }): Promise<Collaborateur[]> {
    const params = new URLSearchParams();
    if (filters?.serviceId) params.append('serviceId', filters.serviceId);

    const { data } = await api.get<{ success: boolean; data: { collaborateurs: Collaborateur[] } }>(
      `/collaborateurs?${params.toString()}`
    );
    return data.data.collaborateurs;
  },

  async getAll(): Promise<Collaborateur[]> {
    return this.list();
  },

  async getById(id: string): Promise<Collaborateur> {
    const { data } = await api.get<{ success: boolean; data: Collaborateur }>(`/collaborateurs/${id}`);
    return data.data;
  },

  async create(collaborateurData: CreateCollaborateurRequest): Promise<Collaborateur> {
    const { data } = await api.post<{ success: boolean; data: { collaborateur: Collaborateur } }>(
      '/collaborateurs',
      collaborateurData
    );
    return data.data.collaborateur;
  },

  async update(id: string, collaborateurData: UpdateCollaborateurRequest): Promise<Collaborateur> {
    const { data } = await api.put<{ success: boolean; data: Collaborateur }>(
      `/collaborateurs/${id}`,
      collaborateurData
    );
    return data.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/collaborateurs/${id}`);
  },
};

export default collaborateursService;
